import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Preloader from "./Preloader";

const isAuthenticated = () => {
  return localStorage.getItem("user") != null;
};

const PrivateRoute = ({ element }) => {
  const [loaded, setLoaded] = useState(false);
  const [showSettings, setShowSettings] = useState(true);

  useEffect(() => {
    setShowSettings(localStorage.getItem("settingsVisible") !== "false");
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  const toggleSettings = () => {
    const newState = !showSettings;
    setShowSettings(newState);
    localStorage.setItem("settingsVisible", newState);
  };

  if (!isAuthenticated()) {
    return <Navigate to="/signin" replace />;
  }

  return (
    <>
      <Preloader show={!loaded} />
      {loaded && (
        <>
          <Sidebar />
          <main className="content">
            <Navbar />
            {element}
            <Footer toggleSettings={toggleSettings} showSettings={showSettings} />
          </main>
        </>
      )}
    </>
  );
};

export default PrivateRoute;
